import type { SaveStatus } from './SaveStatusIndicator';

/** How long a successful save stays on screen before fading out. */
export const SAVE_STATUS_SUCCESS_DWELL_MS = 2000;

export interface SaveStatusVisibility {
  visible: boolean;
  /** When set, hide after this delay while status remains `saved`. */
  dwellMs: number | null;
}

/**
 * Visibility for the save indicator.
 *
 * Saving and failures stay on screen. Success is shown only after a transition
 * into `saved` (so mount and React StrictMode effect re-runs do not flash),
 * then faded after {@link SAVE_STATUS_SUCCESS_DWELL_MS}. Typing stays hidden.
 */
export function saveStatusVisibility(
  status: SaveStatus,
  previousStatus?: SaveStatus,
): SaveStatusVisibility {
  switch (status) {
    case 'saving':
    case 'error':
    case 'invalid':
      return { visible: true, dwellMs: null };
    case 'saved':
      if (previousStatus && previousStatus !== 'saved') {
        return { visible: true, dwellMs: SAVE_STATUS_SUCCESS_DWELL_MS };
      }
      return { visible: false, dwellMs: null };
    default:
      return { visible: false, dwellMs: null };
  }
}
